/*
 * @Author: Teemo Ding
 * @Date: 2021-12-14 15:12:39
 * @LastEditTime: 2021-12-14 15:19:48
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/ShoppingCartTemplate/ShoppingCartTemplateDetail/tool.ts
 */
export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/',
    name: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_tool_AllShoppingCart_breadcrumbData',
    ),
  },
  {
    url: '',
    name: getI18n(
      'shoppingCartTemplate.shoppingCartTemplate.shoppingCartTemplateDetail_tool_CreateShoppingCart_breadcrumbData',
    ),
  },
];
